<template>
  <div id="page">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>

    <section>
      <div class="col-6 mx-auto center">
        <h1 class="caps">Page Not Found</h1>
        <p>Unfortunately we were unable to find the page: <span class="red">{{ this.$route.params.brokenLink }}</span></p>
        <p>We recently updated our website, so some links may be broken.</p>
        <!-- <p>Searching our site, we were hopefully able to find what you were looking for:</p> -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SubMenu from '@/components/SubMenu'

export default {

  name: 'Page',

  data () {
    return {

    }
  },

  components: {
    SubMenu
  },

  computed: {
    ...mapState([
      'pages'
    ]),
    currentPage () {
      let slug = this.$route.params.page
      if (this.pages.hasOwnProperty(slug)) {
        return this.pages[slug]
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions([
      'getPage'
    ])
  },

  watch: {
    '$route' (to) {
      console.log(to.params.page)
      this.getPage(to.params.page)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
